import React from 'react';
import { useRefinementList } from 'react-instantsearch-hooks';
import { useHits } from 'react-instantsearch-hooks-web';
import { searchUILabels } from '@components/ui/Search';
import classNames from 'classnames';
import { sortBy, uniqBy } from 'lodash-es';

const SizeSelectorUI = (props) => {
  let { size } = props;
  const { hits } = useHits();
  let uniqueSizes = uniqBy(hits, 'named_tags.Size');

  if (!uniqueSizes.length) {
    return null;
  }

  let sortedItems = sortBy(uniqueSizes, 'named_tags.Size');

  return (
    <div className="SizeSelector">
      <header>Size</header>
      <div className="SizeSelector__list">
        {sortedItems.map((item) => {
          return (
            <div
              className={classNames('SizeSelector__item', {
                isSelected: item.named_tags.Size?.trim() === size,
              })}
            >
              <a href={`/products/${item.handle}`}>{item.named_tags.Size}</a>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SizeSelectorUI;
